import { CheckboxFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

const blockRemoveMarginField = {
    displayName: "Remove Top and Bottom Margins",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
} as CheckboxFieldDefinition;

export default blockRemoveMarginField;
